import VerificationCodeField from './VerificationCodeField';

export default VerificationCodeField;
export type { VerificationCodeFieldProps } from './VerificationCodeField';
